import { Component, OnInit } from '@angular/core';
import { DialogDataModel } from '../../../models/dialog-data.model';

@Component({
  selector: 'info-dialog',
  templateUrl: './info-dialog.component.html',
})
export class InfoDialogComponent implements OnInit {

  public data: DialogDataModel = new DialogDataModel();

  public closeButtonEnabled: boolean = true;

  /**
   * Constructor
   */
  public constructor() { }

  /**
   * Initialize the Component
   *
   * @return void
   */
  public ngOnInit(): void {}

}
